import React from "react";
import { AlertTriangle } from "lucide-react";

export default function DisclaimerBanner() {
  const items = [
    "Sourced from public government registries (TN TBI, Henrico County VA) and publicly reported convictions.",
    "This is NOT an official government source — always verify with the linked source record.",
    "If you witness abuse, call 911 or your local Animal Control.",
    "Information shown is as-of the date the source registry was last observed.",
  ];
  // Triple the list so the infinite-scroll marquee has no gap; use a stable
  // composite key (text + loop-index) rather than just the array index.
  const loop = (items) =>
    [0, 1, 2].flatMap((loopIdx) =>
      items.map((text) => ({ key: `${loopIdx}-${text}`, text }))
    );
  return (
    <div
      className="w-full bg-zinc-900 text-white overflow-hidden border-b border-red-600"
      data-testid="disclaimer-marquee"
    >
      <div className="flex items-center gap-4 py-2 marquee-track whitespace-nowrap">
        {loop(items).map(({ key, text }) => (
          <span
            key={key}
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] font-mono"
          >
            <AlertTriangle size={12} className="text-red-500 flex-shrink-0" />
            {text}
            <span className="text-red-500 px-4">×</span>
          </span>
        ))}
      </div>
    </div>
  );
}
